import { useQueryClient } from "react-query"
import { TApiProjectSection } from "../../api-client/types"

interface Props {
  projectSectionId: string
}

export const useGetProjectSection = (props: Props) => {
  const {
    projectSectionId,
  } = props

  const queryClient = useQueryClient()

  // Get all cached data for "project-sections" queries
  const cachedData = queryClient.getQueriesData<{ projectSections: TApiProjectSection[] }>([
    "project-sections",
  ])

  for (const [, result] of cachedData) {
    if (!result) continue

    const section = result.projectSections.find((ps) => ps.id == projectSectionId)

    if (section) {
      return section
    }
  }

  return null // Project section not found
}